export default __webpack_public_path__ + "static/media/brackets1.b097128a.png";